import { useState } from "react";

import { createLogger } from "../services/Logger";

export const useSessionStorage = (key: string, initialValue: any) => {
  const log = createLogger("SessionStorage");
  const [storedValue, setStoredValue] = useState(() => {
    if (typeof window === "undefined") {
      return initialValue;
    }

    try {
      const item = window.sessionStorage.getItem(key);
      const parsed = item ? JSON.parse(item) : initialValue;
      log.debug("init", { key, parsed });
      return parsed;
    } catch (error) {
      log.warn("init:failed", { key, error });
      return initialValue;
    }
  });

  const setValue = (value: (val: any) => any) => {
    try {
      const valueToStore =
        value instanceof Function ? value(storedValue) : value;
      setStoredValue(valueToStore);
      if (typeof window !== "undefined") {
        window.sessionStorage.setItem(key, JSON.stringify(valueToStore));
      }
      log.debug("set", { key, valueToStore });
    } catch (error) {
      log.warn("set:failed", { key, error });
    }
  };

  const clear = () => {
    try {
      setStoredValue(initialValue);
      if (typeof window !== "undefined") {
        window.sessionStorage.removeItem(key);
      }
      log.debug("clear", { key });
    } catch (error) {
      log.warn("clear:failed", { key, error });
    }
  };

  return [storedValue, setValue, clear] as const;
};
